export const LOGIN = 'LOGIN';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const CODE_LOGIN = 'CODE_LOGIN';
export const CODE_LOGIN_PROGRESS = 'CODE_LOGIN_PROGRESS';
export const FIRST_LOGIN = 'FIRST_LOGIN';
export const FIRST_LOGIN_ISVALID = 'FIRST_LOGIN_ISVALID'; 